import { render, staticRenderFns } from "./ProposalAssetsRouterView.vue?vue&type=template&id=741fa418&"
import script from "./ProposalAssetsRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalAssetsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports